import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const FacebookIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      strokeWidth={0.8}
      d="M8.928 10.216h1.317V8.935c0-.564.014-1.435.425-1.976C11.1 6.388 11.693 6 12.712 6c1.662 0 2.36.238 2.36.238l-.329 1.952s-.548-.16-1.06-.16-.97.185-.97.697v1.489h2.1l-.147 1.907h-1.954v6.627h-2.466v-6.627H8.928v-1.907Z"
    />
  </Svg>
)
export default FacebookIcon